import { render } from "./AssignmentsSection.vue?vue&type=template&id=016cda50&scoped=true"
import script from "./AssignmentsSection.vue?vue&type=script&lang=js"
export * from "./AssignmentsSection.vue?vue&type=script&lang=js"

import "./AssignmentsSection.vue?vue&type=style&index=0&id=016cda50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016cda50"]])

export default __exports__